import { render, staticRenderFns } from "./JumpCloudOidcCallback.vue?vue&type=template&id=56181ff2&"
import script from "./JumpCloudOidcCallback.vue?vue&type=script&lang=js&"
export * from "./JumpCloudOidcCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports